import React, { useState, useEffect } from "react";
import { ReactComponent as TimeIcon } from '../../assets/icons/TimeIcon.svg'
const CalendarModal = ({ isVisible, onClose, onDatesSelect, initialDates = [] }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
useEffect(() => {
  setSelectedDays(initialDates);
  if (initialDates.length > 0) {
    const firstDate = initialDates[0];
    const hours = firstDate.getHours().toString().padStart(2, '0');
    const minutes = firstDate.getMinutes().toString().padStart(2, '0');
    setSelectedTime(`${hours}:${minutes}`);
  } else {
    setSelectedTime('');
  }
}, [initialDates]);
const getDaysInMonth = (year, month) => {
const date = new Date(year, month, 1);
const days = [];
while (date.getMonth() === month) {
days.push(new Date(date));
date.setDate(date.getDate() + 1);
}
return days;
};
const getStartingDay = (year, month) => {
const date = new Date(year, month, 1);
return date.getDay();
};
const daysOfWeek = ["D", "L", "M", "M", "J", "V", "S"];
  const handleDayClick = (day) => {
    const dayTimestamp = day.setHours(0, 0, 0, 0);
    const dayIndex = selectedDays.findIndex(d => d.setHours(0, 0, 0, 0) === dayTimestamp);
    if (dayIndex > -1) {
      const newSelectedDays = [...selectedDays];
      newSelectedDays.splice(dayIndex, 1);
      setSelectedDays(newSelectedDays);
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };
const renderCalendar = () => {
const today = new Date();
const year = currentDate.getFullYear();
const month = currentDate.getMonth();
const daysInMonth = getDaysInMonth(year, month);
const startingDay = getStartingDay(year, month);
const calendarDays = [];
for (let i = 0; i < startingDay; i++) {
calendarDays.push(
<div key={`empty-${i}`} className="calendar-day empty"></div>
);
}
    daysInMonth.forEach((day, index) => {
      const isToday = day.getDate() === today.getDate() && day.getMonth() === today.getMonth() && day.getFullYear() === today.getFullYear();
      const isSelected = selectedDays.some(selectedDay => 
        selectedDay.getDate() === day.getDate() &&
        selectedDay.getMonth() === day.getMonth() &&
        selectedDay.getFullYear() === day.getFullYear()
      );
      const dayClass = `calendar-day ${isToday ? "today" : ""} ${isSelected ? "selected" : ""}`;
      calendarDays.push(
        <div 
          key={index} 
          className={dayClass}
          onClick={() => handleDayClick(day)}
        >
          {day.getDate()}
        </div>
      );
    });
    return calendarDays;
  };
const goToPreviousMonth = () => {
setCurrentDate(
new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
);
};
const goToNextMonth = () => {
setCurrentDate(
new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
);
};
const handleTimeChange = (e) => {
let value = e.target.value.replace(/\D/g, ""); 
if (value.length > 2) {
value = value.slice(0, 2) + ":" + value.slice(2, 4);
}
if (value.length > 5) {
value = value.slice(0, 5);
}
setSelectedTime(value);
};
const modalClass = `calendar-modal-overlay ${isVisible ? "visible" : ""}`;
const handleDoneClick = () => {
  if (selectedDays.length === 0) {
    onDatesSelect({ selectedDates: [], selectedTime: '' });
    onClose();
    return;
  }
  const finalDates = selectedDays.map(day => new Date(day.getFullYear(), day.getMonth(), day.getDate()));
  onDatesSelect({ selectedDates: finalDates, selectedTime: selectedTime });
  onClose();
};
return (
<div className={modalClass}>
<div className="calendar-modal-content">
<div className="calendar-container">
<div className="calendar-navigation">
<button onClick={goToPreviousMonth}>&lt;</button>
<span>
{currentDate.toLocaleString("es-ES", {
month: "long",
year: "numeric",
})}
</span>
<button onClick={goToNextMonth}>&gt;</button>
</div>
<div className="calendar-header">
{daysOfWeek.map((day, index) => (
<div key={index} className="day-of-week">
{day}
</div>
))}
</div>
<div className="calendar-grid">{renderCalendar()}</div>
</div>
<div className="time-input-container">
<TimeIcon className="time-input-icon"/>
<input
id="task-time"
type="text" 
placeholder="Establecer hora" 
value={selectedTime}
onChange={handleTimeChange}
className="task-time-input"
/>
</div>
<div className="modal-actions">
<button  onClick={onClose} className="modal-close-button">
Cancelar
</button>
<button onClick={handleDoneClick} className="done-button">
Hecho
</button>
</div>
</div>
</div>
);
};
export default CalendarModal;